import { InjectionToken } from '@angular/core';

export interface MomentService {
  formatDate(value: string | Date, format: string, timezone?: string): string;
}

export const MOMENT_SERVICE = new InjectionToken<MomentService>('SharedMomentService');
